import { Directive, Input } from '@angular/core';
import { IKeyValue } from '../../../models';

@Directive()
export abstract class TicketQuestionCardBaseComponent {
  @Input() question: IKeyValue<string>;
}
